﻿'use strict';

/**
 * @ngdoc function
 * @name ntmApp.controller:scenarioChangesListController
 * @description
 * # scenarioChangesListController
 * Controller of the ntmApp
 */
angular.module('ntmApp')
  .controller('scenarioChangesListController', ['$uibModalInstance', '$timeout', '$scope', 'data', 'ForecastService', 'ScenarioChangesListFilter', 'ChangedItemsTranslator', 'Constants', 'ForecastConfirmationService', 'FlashService', 'Utils',
      function ($uibModalInstance, $timeout, $scope, data, ForecastService, ScenarioChangesListFilter, ChangedItemsTranslator, Constants, ForecastConfirmationService, FlashService, Utils) {

      $scope.Filter = new  ScenarioChangesListFilter();
      $scope.activityType = Constants.ActivityTypes;

      function initData() {
          $scope.scenarioName = data.scenarioName;

          $scope.loading = true;

          var request = {
              scenarioBreadcrumb: data.scenarioId,
              forecastScope: data.scopes.map(function (scope) {
                  return scope.id.trim();
              }),
              forecastView: data.viewMode
          };

          ForecastService.ListAllChanges(request).then(function (result) {

              if (result.success) {
                  $scope.activities = result.data.scenarioAllChanges;
                  $scope.filterDataSource = result.data.listAllChangeFilter;
                  $scope.applyFilter();
              }

              $scope.loading = false;
          });
      }

      $scope.revertChanges = function () {

          var revertAction = function () {

              var toRevert = getMarkedActivities();
              var loading = FlashService.Loading();
              ForecastService.SaveListAllChanges(toRevert).then(function (result) {

                  if (result.success) {
                      FlashService.Success('Changes successfully reverted.');
                      $scope.close('revertChanges');
                  }

                  loading.dismiss();
              });
          };

          ForecastConfirmationService.YesNoConfirmation("Are you sure you want to revert all checked activities back to their Current Forecast state?",
                                                        null,
                                                        {
                                                            title: 'Revert Changes',
                                                            no: 'Never mind',
                                                            yes: 'Yes, revert changes for checked activities'
                                                        })
                                     .Yes(revertAction)
                                     .Ask();

      };

      function getMarkedActivities() {

          return $scope.activities.filter(function (activity) {
              return activity.revert;
          }).map(transformActivityToRevertChangesRequest);
      }

      function transformActivityToRevertChangesRequest(activity) {

          return {
              durationUnit:activity.durationUnit,
              per:activity.per,
              scenarioScheduleId: activity.scenarioScheduleId,
              currentForecastAssigneeId: activity.currentForecastAssigneeId,
              currentForecastScheduleDate: activity.currentForecastScheduleDate,
              currentForecastStatusId: activity.currentForecastStatusId,
              currentForecastMetricDuration: activity.currentForecastMetricDuration,
              currentForecastDuration: activity.currentForecastDuration,
              category: activity.category,
              reScheduled: activity.reScheduled,
              scenarioScheduleDate: activity.scenarioScheduleDate,

          };
      }

      $scope.noChangesMarkedToRevert = function () {

          if ($scope.activities) {
              return !$scope.activities.some(function (activity) {
                  return activity.revert;
              });
          }

          return true;
      };

      $scope.getMarkedActivitiesCount = function () {

          if ($scope.activities) {
              var markedActivitiesCount = $scope.activities.filter(function (activity) {
                  return activity.revert;
              }).length;

              return markedActivitiesCount > 0 ? markedActivitiesCount : '';
          }

          return '';
      };

      $scope.applyFilter = function () {
          var filtered = $scope.Filter.filter($scope.activities);
          $scope.filteredGrouppedActivities = ChangedItemsTranslator.ToGroup(filtered, $scope.activities);
      };

      $scope.onActivityRevertChanged = function (activity, byGroup, byLocate) {
          
          if (byLocate) {
              byLocate.revert = $scope.activities.filter(function (activity) {
                  return activity.location === byLocate.key &&
                         activity.groupName === byGroup.key;
              }).every(function (activity) {
                  return activity.revert;
              });
          }

          byGroup.revert = $scope.activities.filter(function (activity) {
              return activity.groupName === byGroup.key;
          }).every(function (activity) {
              return activity.revert;
          });

          $scope.applyFilter();
      };

      $scope.onLocateRevertChanged = function (byLocate, byGroup) {

          $scope.activities.filter(function (activity) {
              return activity.location === byLocate.key &&
                     activity.groupName === byGroup.key;
          }).forEach(function (activity) {
              activity.revert = byLocate.revert;
          });

          byGroup.revert = $scope.activities.filter(function (activity) {
              return activity.groupName === byGroup.key;
          }).every(function (activity) {
              return activity.revert;
          });

          $scope.applyFilter();
      };

      $scope.onGroupRevertChanged = function (byGroup) {

          $scope.activities.filter(function (activity) {
              return activity.groupName === byGroup.key;
          }).forEach(function (activity) {
              activity.revert = byGroup.revert;
          });

          $scope.applyFilter();
      };

      $scope.close = function (closeType) {
          $uibModalInstance.close(closeType || false);
      };

      $scope.dismiss = function () {
          $uibModalInstance.dismiss();
      };

      $scope.isAutoCompleteEmpty = function (obj) {
          return Utils.IsTypeheadEmpty(obj);
      };

      initData();

  }]);